/**
 * Created by mvasim on 12/9/17.
 */
import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';


/**
 * This component is used to provides navigation for paged information, typically used with a table.
 * To use this component import FoundationModule in Module.
 */
@Component({
  selector: 'fn-pagination',
  templateUrl: 'fn-pagination.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FnPaginationComponent implements OnInit {

  /**
   * Input  member variable
   * used to show current page index , default value is 1 .
   */
  @Input() currentPage = 0;
  /**
   * Input member variable
   * used to show total no of Pages.
   */
  @Input() totalPage = 0;
  /**
   * Input member variable.
   * used to show the number of items per page.
   */
  @Input() pageSize = 0;
  /**
   * Input member variable.
   * used to style pagination component
   */
  @Input() pageClass = '';
  /**
   * Output  member
   * used to emit value to parent component .
   */
  @Output() changePage = new EventEmitter();

  /**
   * Implements onInit event handler.
   * set currentPage value
   */
  ngOnInit() {
    this.currentPage = 1;
  }

  /**
   * Member function
   * onclick Naviagte to first Page And call change page Event Emiiter.
   */
  firstPage() {
    this.currentPage = 1;
    this.changePage.emit(this.currentPage);
  }
/**
   * Member function
   * onclick Naviagte to Previous Page And call change page Event Emiiter.
   */
  prevPage() {
    this.currentPage = this.currentPage - 1;
    this.changePage.emit(this.currentPage);
  }
/**
   * Member function
   * onclick Naviagte to Next Page And call change page Event Emiiter.
   */
  nextPage() {
    this.currentPage = this.currentPage + 1;
    this.changePage.emit(this.currentPage);
  }

  /**
   * Member function
   * onclick Naviagte to Last Page And call change page Event Emiiter.
   */
  lastPage() {
    this.currentPage = this.totalPage;
    this.changePage.emit(this.currentPage);
  }


}
